<div class="max-w-md mx-auto mt-12 p-3">

  @if (requirements() && requirements()!.fields.length) {
    <div class="rounded bg-slate-800 p-3 mb-6">
      We want to create a friendly environment where everyone has a chance to get to know each other.
      So, please make sure your profile includes
      <app-profile-fields [fields]="requirements()!.fields"></app-profile-fields>
    </div>
  }

  @if (!loading() && user()) {
    <div>
      <div class="flex flex-row gap-6 items-center">
        <div class="relative text-center">
          <app-avatar [user]="user()" size="lg"></app-avatar>
          @if (user()!.profileImage) {
            <div class="absolute right-0 bottom-0">
              <button mat-mini-fab  color="primary"  [matMenuTriggerFor]="selfieMenu">
                <fa-icon icon="caret-down"></fa-icon>
              </button>
              <mat-menu #selfieMenu="matMenu">
                <button mat-menu-item (click)="takeSelfie()">
                  <fa-icon icon="camera" class="mr-3"></fa-icon>
                  Take selfie
                </button>
                <button mat-menu-item (click)="deleteSelfie()" [disabled]="!user()!.profileImage">
                  <fa-icon icon="trash" class="mr-3"></fa-icon>
                  Delete selfie
                </button>
              </mat-menu>
            </div>
          }
          @if (!user()!.profileImage) {
            <div class="absolute right-0 bottom-0">
              <button mat-mini-fab color="primary" (click)="takeSelfie()">
                <fa-icon icon="camera"></fa-icon>
              </button>
            </div>
          }
        </div>
        <div>
          <strong class="text-xl">{{user()!.givenName}} {{user()!.familyName}}</strong>
          <br/>
          {{user()!.email}}
          <span class="text-muted px-3">
            <fa-icon icon="eye" matTooltip="Your email address will only be visible to teaching staff"></fa-icon>
          </span>
        </div>
      </div>
      <div class="mt-6">
        <mat-form-field class="w-full">
          <mat-label>Bio</mat-label>
          <textarea matInput class="w-full" rows="6" [(ngModel)]="user()!.bio" placeholder="Tell us a little about yourself"></textarea>
        </mat-form-field>
      </div>
      @if (missingFields && missingFields.length) {
        <div class="text-negative my-6">
          You must provide
          <app-profile-fields [fields]="missingFields"></app-profile-fields>
          to continue.
        </div>
      }
      <div class="flex flex-row justify-end gap-3">
        <button (click)="save()" mat-flat-button color="primary">Save</button>
      </div>
    </div>
  }

</div>
